export default __webpack_public_path__ + "static/media/snapchat.4f54dcb7.svg";